module.exports = __webpack_public_path__ + "caa81ad9387237d911d664aa3966f606.svg";


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-flag-kit/assets/RS.svg
// module id = tVmb
// module chunks = 0